import React from 'react';

import { loginURL } from '@src/global/loginURL';
import { removeJwt } from '@src/utils/jwtHelpers';

import styles from './error.scss';

import bootstrap from '@src/css/bootstrap.scss';

/**
 * Error401 - 401 error page
 */

const Error401 = () => {
    const setLocalStorageToNoneAndRefreshPage = () => {
        removeJwt();
        window.location.replace(loginURL());
    };

    return (
        <div id="home" className={`col-12 ${styles.error_page}`}>
            <div className={bootstrap.container}>
                <div className={bootstrap.row}>
                    <div className={`${bootstrap.col} ${bootstrap['text-center']}`}>
                        <div className="error-container">
                            <h1>Your Producer News Portal session has ended</h1>
                            <p>For your security, sessions automatically end.</p>
                            <p className="pt-5">
                                <a className="btn btn-primary" tabIndex={0} onClick={setLocalStorageToNoneAndRefreshPage}>Log In Again</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error401;
